import styled from "@emotion/styled";
import colors from "styles/colors";
export const StyledAiMenuComponent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  align-content: stretch;
  gap: 0;
  width: 100%;

  &.ai-platform-menu {
    .ai-platform-left {
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 460px;
      min-width: 460px;
      max-width: 460px;
      padding-right: 16px;
      overflow: visible;
    }

    .menu-section-title {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      gap: 6px;

      &.align-to-link {
        margin-left: 0;
        padding-left: 8px;
      }

      .monday-logo-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        flex-shrink: 0;

        svg {
          width: 100%;
          height: 100%;
        }
      }
    }

    .menu-section-subtitle {
      font-size: 12px;
      font-weight: 400;
      line-height: 1.25rem;
      text-transform: none;
      color: #676879;
      margin: 8px 0 4px 0;
      padding-left: 8px;
      flex-shrink: 0;
    }

    .use-case-grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      column-gap: 28px;
      row-gap: 14px;
      min-width: 0;
      align-content: start;
      overflow: visible;

      .descriptive-link-block {
        width: 100%;
        min-width: 0;
        min-height: 46px;
        max-height: 60px;
        box-sizing: content-box;
        align-items: center;
        padding: 4px 8px;
        gap: 12px;
        border-radius: 8px;

        .details {
          min-width: 0;
          justify-content: center;
          gap: 2px;
        }

        .details .title {
          white-space: normal;
          font-size: 14px;
          line-height: 1.25;
          font-weight: 400;
        }

        .details .description {
          font-size: 12px;
          font-weight: 300;
          line-height: 100%;
          color: ${colors.mud};
          white-space: nowrap;
        }
      }
    }

    .use-case-grid .descriptive-link-block > img.icon {
      width: 35.2px;
      height: 38px;
      border-radius: 6px;
      object-fit: cover;
    }

    .create-own-solution-link {
      flex-shrink: 0;
      margin-top: auto;

      .secondary-button {
        a {
          font-size: 12px;
          font-weight: 400;
          color: #676879;
        }

        .secondary-button-text {
          font-size: 12px;
          font-weight: 400;
        }
      }
    }

    .ai-platform-right {
      display: flex;
      flex-direction: column;
      gap: 10px;
      flex: 5;
      min-width: 0;
      padding-left: 8px;
      overflow: visible;
    }

    .capabilities-main-title {
      flex-shrink: 0;
      margin-bottom: 10px;
    }

    .capabilities-columns {
      display: flex;
      flex-direction: row;
      gap: 24px;
      min-width: 0;
      align-items: flex-start;
    }

    .capabilities-column {
      display: flex;
      flex-direction: column;
      gap: 36px;
      flex: 1;
      min-width: 0;
    }

    .capability-group-title {
      font-size: 12px;
      font-weight: 400;
      text-transform: none;
      color: #676879;
      margin: 0 0 14px 0;
      display: block;
    }

    .capability-links {
      display: flex;
      flex-direction: column;
      gap: 8px;
      min-width: 0;

      .mini-link-item {
        width: 100%;
        max-width: 100%;
        height: auto;
        min-height: 20px;
        box-sizing: border-box;
        padding: 6px 8px 6px 0;
        font-size: 14px;
        font-weight: 500;
        color: #323338;
        gap: 8px;

        .text {
          font-weight: 500;
          color: #323338;
          white-space: nowrap;
        }
      }

      .icon-container {
        width: 20px;
        height: 20px;
        align-items: center;
        justify-content: center;
      }

      .icon-container img,
      .icon-container svg {
        width: 20px;
        height: 20px;
        object-fit: contain;
      }
    }
  }

  &.ai-platform-menu.is-wide-locale .ai-platform-left {
    width: 600px;
    min-width: 600px;
    max-width: 600px;
  }
`;
